import { QueryClient } from '@tanstack/react-query';

export function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: (failureCount, error: unknown) => {
          const status = (error as { response?: { status?: number }; status?: number } | null)
            ?.response?.status ?? (error as { status?: number } | null)?.status;
          if (status === 401) return false;
          if (status === 403) return false;
          return failureCount < 2;
        },
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}

export const queryClient = makeQueryClient();

// Everything is private unless a query explicitly opts into public caching.
// Cancel first so a response from the old session cannot repopulate the cache.
export function clearPrivateQueries(): void {
  const filters = { predicate: (query: { meta?: Record<string, unknown> }) => query.meta?.public !== true };
  void queryClient.cancelQueries(filters);
  queryClient.removeQueries(filters);
}
